import { sortFlyersFactory } from '@peachjar/flyer-email-builder/dist/api/SortFlyers'

export const mapper = f => ({
  id: f.flyer_id,
  submittedAt: new Date(Number(f.submitted_at) * 1000),
  minTargetGrade: f.min_target_grade,
  maxTargetGrade: f.max_target_grade,
  ownerType: f.owner_type
})

const sortFn = sortFlyersFactory(mapper)

export default sortFn



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerGrid/sortFlyers.js